<template>
  <el-dialog :title="dialogTitle" :close-on-click-modal="false" :visible.sync="visible" width="680px">
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="dialogReadonly && dataForm.supplierId" class="doc-dialog-actions">
          <el-button-group>
            <el-button v-if="isAuth('purchase:supplier:update')" type="primary" size="small" @click="editFromView">修改</el-button>
            <el-button v-if="isAuth('purchase:supplier:delete')" type="danger" size="small" @click="deleteHandle">删除</el-button>
          </el-button-group>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="dataForm" :rules="dataRule" label-width="100px">
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="供应商编码" prop="supplierCode">
            <el-input v-model="dataForm.supplierCode" :disabled="dialogReadonly" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供应商名称" prop="supplierName">
            <el-input v-model="dataForm.supplierName" :disabled="dialogReadonly" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="联系人" prop="contactPerson">
            <el-input v-model="dataForm.contactPerson" :disabled="dialogReadonly" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="dataForm.phone" :disabled="dialogReadonly" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="地址" prop="address">
        <el-input v-model="dataForm.address" :disabled="dialogReadonly" />
      </el-form-item>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="税号" prop="taxNumber">
            <el-input v-model="dataForm.taxNumber" :disabled="dialogReadonly" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="启用" prop="isenabled">
            <el-switch v-model="enabledSwitch" :disabled="dialogReadonly" active-color="#13ce66" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="开户银行" prop="bankName">
            <el-input v-model="dataForm.bankName" :disabled="dialogReadonly" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="银行账号" prop="bankNumber">
            <el-input v-model="dataForm.bankNumber" :disabled="dialogReadonly" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="dataForm.remark" type="textarea" :rows="3" :disabled="dialogReadonly" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!dialogReadonly" type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { docInfo, docSave } from '../../api/erp/doc'
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  data() {
    return {
      visible: false,
      dialogReadonly: false,
      dialogTitle: '新增供应商',
      enabledSwitch: true,
      permCodes: [],
      dataForm: {
        supplierId: '', supplierCode: '', supplierName: '', contactPerson: '', phone: '',
        address: '', taxNumber: '', bankName: '', bankNumber: '', isenabled: '0', remark: ''
      },
      dataRule: {
        supplierCode: [{ required: true, message: '供应商编码不能为空', trigger: 'blur' }],
        supplierName: [{ required: true, message: '供应商名称不能为空', trigger: 'blur' }]
      }
    }
  },
  created() {
    fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    editFromView() {
      this.dialogReadonly = false
      this.dialogTitle = '修改供应商'
    },
    deleteHandle() {
      if (!this.dataForm.supplierId) return
      this.$confirm('确定删除该供应商?', '提示', { type: 'warning' }).then(() => {
        request.post('/purchase/supplier/delete', { supplierId: this.dataForm.supplierId }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    },
    init(id, readonly) {
      this.dialogReadonly = !!readonly
      this.dialogTitle = readonly ? '查看供应商' : (id ? '修改供应商' : '新增供应商')
      this.visible = true
      this.$nextTick(() => {
        if (this.$refs.dataForm) this.$refs.dataForm.resetFields()
        this.dataForm = {
          supplierId: id || '', supplierCode: '', supplierName: '', contactPerson: '', phone: '',
          address: '', taxNumber: '', bankName: '', bankNumber: '', isenabled: '0', remark: ''
        }
        this.enabledSwitch = true
        if (id) {
          docInfo('/purchase/supplier', id).then(res => {
            const body = res.data || {}
            Object.assign(this.dataForm, body)
            this.enabledSwitch = body.isenabled !== '1'
          }).catch(() => {})
        }
      })
    },
    dataFormSubmit() {
      this.dataForm.isenabled = this.enabledSwitch ? '0' : '1'
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        docSave('/purchase/supplier', this.dataForm, 'supplierId').then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    }
  }
}
</script>

<style scoped>
.doc-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 28px;
}
.doc-dialog-title {
  font-size: 16px;
}
</style>
